import { TextField } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles<{ minWidth: number; maxWidth: number }>()((theme, props) => ({
  smallTextField: {
    width: '100%',
    minWidth: props.minWidth && `${props.minWidth}px`,
    maxWidth: props.maxWidth && `${props.maxWidth}px`,
    display: 'flex',
    flex: '1 1 auto',
    padding: '0px',
    '& > input': {
      padding: '3px 6px',
    },
    fontSize: '14px',
  },
  smallTextFieldHeight: {
    padding: '0px',
    '&.MuiOutlinedInput-multiline': {
      padding: '3px 6px',
    },
  },
  icon: {
    padding: '0px 5px',
    cursor: 'pointer',
    height: '27px',
    width: '27px',
    color: '#8E9195',
  },
  inputNumber: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
}));

export const CustomNumberField = ({
  open,
  minWidth = 0,
  maxWidth = 100,
  value,
  bulletPointOnEnter,
  maxValue,
  minValue,
  ...props
}: {
  /** editing requested from caller */
  open?: boolean;
  minWidth?: number;
  maxWidth?: number;
  value: string | null;
  bulletPointOnEnter?: boolean;
  maxValue?: number;
  minValue?: number;
  [key: string]: any;
}) => {
  const textFieldRef = React.useRef<HTMLInputElement | HTMLTextAreaElement>();
  const { classes, cx } = useStyles({ minWidth, maxWidth });

  React.useEffect(() => {
    if (open) textFieldRef?.current?.focus?.();
  }, [open]);

  const onClear = () => {
    props.onChange(null);
  };

  const _onChange = event => {
    const newValue = event.target.value;
    if (newValue === '' || (Number(newValue) >= 0 && Number(newValue) <= 9999)) {
      props.onChange(newValue === '' ? null : newValue);
    }
  };

  const onKeyDown = event => {
    window.globalThis.keyEvent = event.keyCode;
  };

  return (
    <TextField
      inputRef={textFieldRef}
      onKeyDownCapture={onKeyDown}
      size="small"
      variant="outlined"
      type="number"
      className={cx(classes.smallTextField, classes.inputNumber)}
      InputProps={{
        endAdornment: <CloseIcon className={classes.icon} onClick={onClear} />,
        classes: {
          root: cx(classes.smallTextField, classes.smallTextFieldHeight),
        },
      }}
      inputProps={{
        inputMode: 'numeric',
        pattern: '[0-9]*',
        min: minValue,
        max: maxValue,
      }}
      value={value ?? ''}
      {...props}
      onChange={_onChange}
    />
  );
};
